import PropTypes from 'prop-types';
import React from 'react';

import StateLinksCard from './StateLinksCard';

const newsLinks = [
  {
    title: 'State Capital Bulletins',
    href: '/advocacy/state/capital-bulletin/[slug]',
  },
  {
    title: 'Legislative Preview',
    href: '/advocacy/state/legislative-preview/[slug]',
  },
  {
    title: 'Legislative Wrap-Up',
    href: '/advocacy/state/legislative-wrap-up/[slug]',
  },
  {
    title: 'News Releases',
    href: '/media/news-releases/[slug]',
  },
  {
    title: 'State Environment Report ',
    href: '/advocacy/state/environment-report/[slug]',
  },
];

function NewsLinks({ stateCode }) {
  return <StateLinksCard category="News" iconId={4} links={newsLinks} stateCode={stateCode} />;
}

NewsLinks.propTypes = {
  stateCode: PropTypes.string.isRequired,
};

export default NewsLinks;
